import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";
import labels from "emun.order/_labels";

export default class CartAdditionalInfoController {
	constructor($session) {
		const $ctrl = this;
		basicController($ctrl);
		const bus = ($ctrl.bus = new ServiceBus());
		$ctrl.config = cartConfig;
		$ctrl.cartItem.priceOverride = $ctrl.cartItem.price;
		$ctrl.cartItem.minShipDate = $ctrl.$cart.today;
		$ctrl.labels = labels;

		if ($ctrl.cartItem.product.shipOn && moment.utc($ctrl.cartItem.product.shipOn) > $ctrl.$cart.today)
			$ctrl.cartItem.minShipDate = moment
				.utc($ctrl.cartItem.product.shipOn)
				.startOf("day");

		$ctrl.cartItem.shipOn = moment.utc($ctrl.cartItem.$shipOn).startOf("day");
		$ctrl.allowPriceOverride = false;
		
		if ($session.salesManagementMode && $session.isAgency() && $ctrl.$cart.vendor && $ctrl.$cart.vendor.allowPriceOverride) {
			$ctrl.allowPriceOverride = true;
		}
		if ($session.salesManagementMode && ($ctrl.labels.priceOverride || ($ctrl.cartItem.productId === '*SUMMARY' && $session.isAgency()))) {
			$ctrl.allowPriceOverride = true;
		}
		const items = _.sortBy($ctrl.$cart.items, 'shipOn');
		const shipDates = items.map(item =>
			moment.utc(item.shipOn).format("MM/DD/YYYY")
		);
		$ctrl.actions = _.uniq(shipDates).map(shipdate => ({
			title: shipdate,
			key: shipdate
		}));
		console.info("hi", $ctrl.allowPriceOverride, $ctrl.$cart.vendor.allowPriceOverride);
	}

	submit() {
		const $ctrl = this;
		$ctrl.$close($ctrl.cartItem);
		//		$ctrl.$cart.changeOptions($ctrl.cartItem).then(res => $ctrl.$close(res));
	}
}
